import { CandidateFilterValuesType } from '@/components/CandidateFilter/CandidateFilter.types';
import * as Styles from './CandidateSearchForFilter.styles';

export type AutocompleteComponentType = {
  isFetched: boolean;
  selectedOptions?: string[];
  options: CandidateFilterValuesType[];
  input: string;
  onChangeInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectItem: (item: string | number | Date | string[]) => void;
};

const CandidateSearchForFilterComponent = ({
  options,
  input,
  isFetched,
  onSelectItem,
  onChangeInput,
  selectedOptions,
}: AutocompleteComponentType): JSX.Element => {
  return (
    <Styles.AutocompleteList>
      <Styles.InputText
        placeholder="Search for a candidate"
        type="text"
        value={input}
        onChange={onChangeInput}
      />

      <ul>
        {!options.length && isFetched && (
          <Styles.AutocompleteListItem>
            <Styles.AutocompleteListButton disabled type="button" onClick={() => {}}>
              <p>Not found</p>
            </Styles.AutocompleteListButton>
          </Styles.AutocompleteListItem>
        )}

        {options.map(({ value, node }) => {
          const Element = node;
          const valueAsString = value.toString();
          const isSelected = selectedOptions?.includes(valueAsString);

          return (
            <Styles.AutocompleteListItem key={value.toString()}>
              <Styles.AutocompleteListButton
                type="button"
                onClick={() => {
                  if (!isSelected) {
                    onSelectItem(value);
                  }
                }}
              >
                <Element checked={isSelected} />
              </Styles.AutocompleteListButton>
            </Styles.AutocompleteListItem>
          );
        })}
      </ul>
    </Styles.AutocompleteList>
  );
};

export default CandidateSearchForFilterComponent;
